const typography = {
  // XSmall variants
  xsmall: {
    title: {
      fontFamily: 'PP Neue Montreal',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.02em'
    },
    regular: {
      fontFamily: 'PP Neue Montreal',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.02em'
    }
  },

  // Small variants
  small: {
    title: {
      fontFamily: 'PP Neue Montreal',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.02em'
    },
    regular: {
      fontFamily: 'PP Neue Montreal',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.02em'
    }
  },

  // Medium variants
  medium: {
    title: {
      fontFamily: 'PP Neue Montreal',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.02em'
    },
    regular: {
      fontFamily: 'PP Neue Montreal',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.02em'
    }
  },

  // Navigation specific
  nav: {
    item: {
      fontFamily: 'PP Neue Montreal',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '16px'
    }
  },

  // Large variants
  large: {
    title: {
      fontFamily: 'PP Neue Montreal',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '18px',
      lineHeight: '24px',
      letterSpacing: '0.02em'
    },
    regular: {
      fontFamily: 'PP Neue Montreal',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: '24px',
      letterSpacing: '0.02em'
    }
  },

  // Timecode variants
  timecode: {
    fontFamily: 'Input Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '9px',
    lineHeight: '16px',
    textTransform: 'uppercase'
  },

  // Duration variants
  duration: {
    fontFamily: 'Input Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: '12px'
  }
};

export default typography;